import React, { Component } from 'react';
import css from '../../css/module/billing.css';
import ModalContent from '../ModalContent';
import { post } from '../../util/helpers/ajax-helpers';

export const NAME = 'company';
export const VAT_NUMBER = 'taxNo';
export const STREET = 'street';
export const CITY = 'city';
export const COUNTRY = 'country';
export const ZIP = 'postcode';

export const GERMANY = 'Germany';
export const UNITED_KINGDOM = 'United Kingdom';

const countries = [
  'Afghanistan',
  'Åland Islands',
  'Albania',
  'Algeria',
  'American Samoa',
  'Andorra',
  'Angola',
  'Anguilla',
  'Antarctica',
  'Antigua and Barbuda',
  'Argentina',
  'Armenia',
  'Aruba',
  'Australia',
  'Austria',
  'Azerbaijan',
  'Bahamas',
  'Bahrain',
  'Bangladesh',
  'Barbados',
  'Belarus',
  'Belgium',
  'Belize',
  'Benin',
  'Bermuda',
  'Bhutan',
  'Bolivia, Plurinational State of',
  'Bonaire, Sint Eustatius and Saba',
  'Bosnia and Herzegovina',
  'Botswana',
  'Bouvet Island',
  'Brazil',
  'British Indian Ocean Territory',
  'Brunei Darussalam',
  'Bulgaria',
  'Burkina Faso',
  'Burundi',
  'Cambodia',
  'Cameroon',
  'Canada',
  'Cape Verde',
  'Cayman Islands',
  'Central African Republic',
  'Chad',
  'Chile',
  'China',
  'Christmas Island',
  'Cocos (Keeling) Islands',
  'Colombia',
  'Comoros',
  'Congo',
  'Congo, the Democratic Republic of the',
  'Cook Islands',
  'Costa Rica',
  "Côte d'Ivoire",
  'Croatia',
  'Cuba',
  'Curaçao',
  'Cyprus',
  'Czech Republic',
  'Denmark',
  'Djibouti',
  'Dominica',
  'Dominican Republic',
  'Ecuador',
  'Egypt',
  'El Salvador',
  'Equatorial Guinea',
  'Eritrea',
  'Estonia',
  'Ethiopia',
  'Falkland Islands (Malvinas)',
  'Faroe Islands',
  'Fiji',
  'Finland',
  'France',
  'French Guiana',
  'French Polynesia',
  'French Southern Territories',
  'Gabon',
  'Gambia',
  'Georgia',
  GERMANY,
  'Ghana',
  'Gibraltar',
  'Greece',
  'Greenland',
  'Grenada',
  'Guadeloupe',
  'Guam',
  'Guatemala',
  'Guernsey',
  'Guinea',
  'Guinea-Bissau',
  'Guyana',
  'Haiti',
  'Heard Island and McDonald Islands',
  'Holy See (Vatican City State)',
  'Honduras',
  'Hong Kong',
  'Hungary',
  'Iceland',
  'India',
  'Indonesia',
  'Iran, Islamic Republic of',
  'Iraq',
  'Ireland',
  'Isle of Man',
  'Israel',
  'Italy',
  'Jamaica',
  'Japan',
  'Jersey',
  'Jordan',
  'Kazakhstan',
  'Kenya',
  'Kiribati',
  "Korea, Democratic People's Republic of",
  'Korea, Republic of',
  'Kuwait',
  'Kyrgyzstan',
  "Lao People's Democratic Republic",
  'Latvia',
  'Lebanon',
  'Lesotho',
  'Liberia',
  'Libya',
  'Liechtenstein',
  'Lithuania',
  'Luxembourg',
  'Macao',
  'Macedonia, the former Yugoslav Republic of',
  'Madagascar',
  'Malawi',
  'Malaysia',
  'Maldives',
  'Mali',
  'Malta',
  'Marshall Islands',
  'Martinique',
  'Mauritania',
  'Mauritius',
  'Mayotte',
  'Mexico',
  'Micronesia, Federated States of',
  'Moldova, Republic of',
  'Monaco',
  'Mongolia',
  'Montenegro',
  'Montserrat',
  'Morocco',
  'Mozambique',
  'Myanmar',
  'Namibia',
  'Nauru',
  'Nepal',
  'Netherlands',
  'New Caledonia',
  'New Zealand',
  'Nicaragua',
  'Niger',
  'Nigeria',
  'Niue',
  'Norfolk Island',
  'Northern Mariana Islands',
  'Norway',
  'Oman',
  'Pakistan',
  'Palau',
  'Palestinian Territory, Occupied',
  'Panama',
  'Papua New Guinea',
  'Paraguay',
  'Peru',
  'Philippines',
  'Pitcairn',
  'Poland',
  'Portugal',
  'Puerto Rico',
  'Qatar',
  'Réunion',
  'Romania',
  'Russian Federation',
  'Rwanda',
  'Saint Barthélemy',
  'Saint Helena, Ascension and Tristan da Cunha',
  'Saint Kitts and Nevis',
  'Saint Lucia',
  'Saint Martin (French part)',
  'Saint Pierre and Miquelon',
  'Saint Vincent and the Grenadines',
  'Samoa',
  'San Marino',
  'Sao Tome and Principe',
  'Saudi Arabia',
  'Senegal',
  'Serbia',
  'Seychelles',
  'Sierra Leone',
  'Singapore',
  'Sint Maarten (Dutch part)',
  'Slovakia',
  'Slovenia',
  'Solomon Islands',
  'Somalia',
  'South Africa',
  'South Georgia and the South Sandwich Islands',
  'South Sudan',
  'Spain',
  'Sri Lanka',
  'Sudan',
  'Suriname',
  'Svalbard and Jan Mayen',
  'Swaziland',
  'Sweden',
  'Switzerland',
  'Syrian Arab Republic',
  'Taiwan, Province of China',
  'Tajikistan',
  'Tanzania, United Republic of',
  'Thailand',
  'Timor-Leste',
  'Togo',
  'Tokelau',
  'Tonga',
  'Trinidad and Tobago',
  'Tunisia',
  'Turkey',
  'Turkmenistan',
  'Turks and Caicos Islands',
  'Tuvalu',
  'Uganda',
  'Ukraine',
  'United Arab Emirates',
  'United Kingdom',
  'United States',
  'United States Minor Outlying Islands',
  'Uruguay',
  'Uzbekistan',
  'Vanuatu',
  'Venezuela, Bolivarian Republic of',
  'Viet Nam',
  'Virgin Islands, British',
  'Virgin Islands, U.S.',
  'Wallis and Futuna',
  'Western Sahara',
  'Yemen',
  'Zambia',
  'Zimbabwe',
];

class CompanyDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      saving: false,
      error: null,
      companyInfo: this.props.companyInfo, // an object containing the address and company details
    };
    this.updateCompanyInfo = this.updateCompanyInfo.bind(this);
    this.save = this.save.bind(this);
    this.content = this.content.bind(this);
  }

  componentDidMount() {
    const { companyInfo } = this.state;
    if (companyInfo[COUNTRY].length === 0) {
      const copyOfObj = { ...companyInfo, [COUNTRY]: 'United States' };
      this.setState({
        companyInfo: copyOfObj,
      });
    }
  }

  buildInput(name, key, placeholder) {
    const { companyInfo } = this.state;
    const value = companyInfo[key];
    const onChange = (e) => this.updateCompanyInfo(key, e.target.value);
    return (
      <div className={css.inputLine}>
        <div className={css.formName}>
          <span>{name}</span>
        </div>
        {key === 'country' ? (
          <select onChange={onChange} value={value}>
            {countries.map((c) => (
              <option key={c} value={c}>
                {c}
              </option>
            ))}
          </select>
        ) : (
          <input
            value={value}
            placeholder={placeholder}
            onChange={onChange}
            type="text"
          />
        )}
      </div>
    );
  }

  updateCompanyInfo(key, value) {
    const copyOfObj = { ...this.state.companyInfo, [key]: value };
    this.setState({
      companyInfo: copyOfObj,
    });
  }

  save() {
    this.setState({
      saving: true,
      error: null, // reset
    });
    post(
      'saving company details',
      '/api/subscription/address',
      this.state.companyInfo,
    ).then((json) => {
      if (json.error) {
        this.setState({
          error: json.error,
          saving: false,
        });
      } else {
        this.props.onUpdated(this.state.companyInfo);
      }
    });
  }

  VATCountries() {
    return [
      'Germany',
      'France',
      'Italy',
      'Poland',
      'Sweden',
      'Spain',
      'Netherlands',
      'Romania',
      'Ireland',
      'Hungary',
      'Denmark',
      'Greece',
      'Belgium',
      'Portugal',
      'Bulgaria',
      'Austria',
      'Finland',
      'Czech Republic',
      'Croatia',
      'Luxembourg',
      'Lithuania',
      'Cyprus',
      'Slovenia',
      'Malta',
      'Slovakia',
      'Estonia',
      'Latvia',
      'United Kingdom',
    ];
  }

  requiredFields() {
    return [NAME, STREET, COUNTRY, ZIP];
  }

  validate() {
    const { companyInfo } = this.state;
    const disabled = this.requiredFields().some(
      (field) => companyInfo[field].length === 0,
    );
    return disabled || this.state.saving;
  }

  content() {
    return (
      <div>
        <div className={css.formContainer}>
          {this.buildInput('Company name*', NAME, 'ABC Inc')}
          {this.buildInput('Address 1*', STREET, 'Street name & number')}
          {this.buildInput('Address 2', CITY, 'City or region')}
          {this.buildInput('Zip code*', ZIP, 'Zip or post code')}
          {this.buildInput('Country*', COUNTRY)}
        </div>
        {!this.state.error ? null : (
          <div>
            <br />
            <div className={css.errorMessage}>{this.state.error}</div>
          </div>
        )}
        {!this.VATCountries().includes(
          this.state.companyInfo[COUNTRY],
        ) ? null : (
          <div>
            <p className="margin-top-30">
              <b>Please provide your VAT number</b>
            </p>
            <div className={css.formContainer}>
              {this.buildInput('VAT Number', VAT_NUMBER, 'e.g. GB123123412')}
            </div>
          </div>
        )}
      </div>
    );
  }

  render() {
    const { closeModal } = this.props;

    return (
      <ModalContent
        showLoaderWithHeader={this.state.saving}
        small
        header="Add company details"
        footer
        onSubmit={this.save}
        disabled={this.validate()}
        disableCancel={this.state.saving}
        submitButtonText="Save"
        onClose={closeModal}
      >
        {this.content()}
      </ModalContent>
    );
  }
}

export default CompanyDetails;
